import React, {useState} from 'react';
import { Box, Alert,AlertIcon, AlertTitle } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import {setUpdateMemberPageSize, setUpdateMemberPagination} from "../redux/slices/userMgtUsersSlice";
import CustomTablePage2 from './CustomTablePage2';

const MembersTable = () => {
  const dispatch =  useDispatch();
  const [error] = useState("");
  const errorsArray = Array.isArray(error) ? error : [error];
  const userData = useSelector((state) => state?.userMgtUsers);
  console.log('userData', userData?.allMembers?.data)
 
  const handlePagination = (page) =>{
    dispatch(setUpdateMemberPagination(page));
  };

  const handlePageSize = (size) => {
    dispatch(setUpdateMemberPageSize(size));
  };

  const tableProps = {
    data: userData?.allMembers?.data,
    title: {
        membershipId: "Membership Id",
        fullName: "Full Name",
        membershipCategory: "Membership Category",
        email:"Email",
        phoneNumber: "Phone Number",
        status: "Status",
    },
    dataKeys: [
      "membershipId",
      "fullName",
      "membershipCategory",
      "email",
      "phoneNumber",
      "status",
    ],
    sn: true,
    handlePagination,
    handlePageSize,
    itemsPerPage:userData?.allMembers?.currentPageRecord,
    totalRecord: userData?.allMembers?.totalRecord,
    pageNumber: userData?.memberParams?.page,
    nextPage: userData?.allMembers?.nextPage,
    previousPage: userData?.allMembers?.previousPage,
    pageSize: userData?.memberParams?.pageSize,
    transformRow: (item) => ({
      membershipId: <div style={{cursor:'pointer'}} >{item?.membershipId}</div>,
      fullName: <div style={{cursor:'pointer'}} >{item?.firstName} {item?.otherName} {item?.lastName}</div>,
      membershipCategory: <div style={{cursor:'pointer'}} >{item?.membershipCategory}</div>,
      email: <div style={{cursor:'pointer'}} >{item?.email}</div>,
      phoneNumber: <div style={{cursor:'pointer'}} >{item?.phoneNumber}</div>,
      status: item &&  (
        <Box
          style={{ cursor: "pointer" }}
          color={item?.isActive === true ? "#0ADB13" : "#D11A2A"}
        >
          {item?.isActive === true ? "Active" : "Inactive"}
        </Box>
      ),
    }),
    
  };

  return (
    <Box>
      {
        error &&(
        <Alert status="error" className="mt-3" mb={3}>
            <AlertIcon />
            <AlertTitle>{errorsArray.join(', ')}</AlertTitle>
        </Alert>
        )
        }
      <CustomTablePage2 {...tableProps } />
    </Box>
  )
}

export default MembersTable;